/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EditNoteInput = {|
  noteId?: ?string,
  newNote?: ?string,
|};
export type EditNoteMutationVariables = {|
  input: EditNoteInput
|};
export type EditNoteMutationResponse = {|
  +editNote: ?{|
    +userNote: ?{|
      +id: string,
      +note: string,
    |}
  |}
|};
export type EditNoteMutation = {|
  variables: EditNoteMutationVariables,
  response: EditNoteMutationResponse,
|};
*/


/*
mutation EditNoteMutation(
  $input: EditNoteInput!
) {
  editNote(input: $input) {
    userNote {
      id
      note
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditNotePayload",
    "kind": "LinkedField",
    "name": "editNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteNode",
        "kind": "LinkedField",
        "name": "userNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "note",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditNoteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditNoteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ee12f9cff12afa26a28a260212b02fcb",
    "id": null,
    "metadata": {},
    "name": "EditNoteMutation",
    "operationKind": "mutation",
    "text": "mutation EditNoteMutation(\n  $input: EditNoteInput!\n) {\n  editNote(input: $input) {\n    userNote {\n      id\n      note\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b11d34646f526bb6c4699baa818a0598';

module.exports = node;
